import { createSlice } from "@reduxjs/toolkit";
import Api from "../api/Api";

type State = {
  isLoading: boolean;
  data: Array<Object>;
  error: Object | null;
};

const INITIAL_STATE = {
  isLoading: false,
  data: [],
  error: null,
};

const pagerDutyOnCall = createSlice({
  name: "pagerDutyOnCall",
  initialState: INITIAL_STATE,
  reducers: {
    fetchPagerDutyOnCallStart: (state: State) => {
      state.isLoading = true;
    },
    fetchPagerDutyOnCallSuccess: (state: State, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    fetchPagerDutyOnCallFailed: (state: State, action) => {
      state.isLoading = false;
      state.error = action.payload;
    }
  }
});

export default pagerDutyOnCall.reducer;

const {
  fetchPagerDutyOnCallStart,
  fetchPagerDutyOnCallSuccess,
  fetchPagerDutyOnCallFailed,

} = pagerDutyOnCall.actions;

export const fetchPagerDutyOnCall = () => async (dispatch: Function) => {
  try {
    dispatch(fetchPagerDutyOnCallStart());
    const api = new Api();
    const result = await api.getPagerDutyOnCall();
    dispatch(fetchPagerDutyOnCallSuccess(result));
  } catch (err) {
    dispatch(fetchPagerDutyOnCallFailed(err));
  }
};